import { render, staticRenderFns } from "./InvoiceHistory.vue?vue&type=template&id=32bb72e5&scoped=true"
import script from "./InvoiceHistory.vue?vue&type=script&lang=js"
export * from "./InvoiceHistory.vue?vue&type=script&lang=js"
import style0 from "./InvoiceHistory.vue?vue&type=style&index=0&id=32bb72e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb72e5",
  null
  
)

export default component.exports